@if (isPartnerMode()) {
    <div class="relative bottom-0 w-full">
        <div class="flex w-full flex-col items-center bg-malou-blue px-16 py-6 md:px-6 md:py-4">
            <span class="malou-text-14--regular text-malou-white">{{ poweredByText() }}</span>
        </div>
    </div>
} @else {
    <div class="relative bottom-0 w-full">
        <div class="flex w-full flex-col items-center gap-12 bg-malou-blue px-16 py-12 md:px-6 md:py-8">
            <div
                class="malou-text-32--regular md:malou-text-28--regular font-passion-one uppercase text-malou-white"
                [innerHTML]="'maloupe.logo_footer' | translate"></div>
            <div class="logo-container flex h-[72px] items-center justify-between self-stretch sm:gap-6 sm:overflow-scroll sm:pb-2">
                @if (!isEnglish()) {
                    <img class="h-[72px]" [src]="'poulet-braise' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[120px]" [src]="'beaumarly' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[95px]" [src]="'delarte' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[95px]" [src]="'bioburger' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[100px]" [src]="'cotesushi' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[72px]" [src]="'groupe-bertrand' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[60px]" [src]="'krispy-kreme' | logoPathResolver: { folder: 'restaurants' }" />
                } @else {
                    <img class="h-[110px]" [src]="'daniel' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[60px]" [src]="'krispy-kreme' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[120px]" [src]="'maison-close' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[70px]" [src]="'mila' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[70px]" [src]="'noble' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[100px]" [src]="'breads-bakery' | logoPathResolver: { folder: 'restaurants' }" />
                    <img class="h-[110px]" [src]="'rdg' | logoPathResolver: { folder: 'restaurants' }" />
                }
            </div>
        </div>
    </div>
}
